// @flow

import type { Route } from './types';

const match = (predicate, value) =>
  predicate === value || (typeof predicate === 'function' && predicate(value));

export default (route: Route, predicates: { [string]: any }) =>
  Object.keys(predicates).reduce((accum, key) => accum && match(predicates[key], route[key]), true);
